import React, { useEffect, useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';

export const GoogleLoginButton = ({ onSuccess, onError, text, lang }) => {

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      // Decodificar el token JWT de Google
      const decoded = jwtDecode(credentialResponse.credential);
      
      console.log('✅ Usuario autenticado con Google:', {
        email: decoded.email,
        name: decoded.name,
        picture: decoded.picture,
      });

      // Enviar al backend PHP de Moodle
      const response = await fetch(
        'https://admin.aprendersteam.com/local/tipddy/services/google_auth.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: decoded.email,
            name: decoded.name,
            google_id: decoded.sub,
            picture: decoded.picture,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        console.log('✅ Login exitoso:', data);
        onSuccess({
          key: data.userkey,
          username: data.username,
          token: data.token,
          userid: data.userid,
        });
      } else {
        console.error('❌ Error del servidor:', data.error);
        onError(data.error || 'Error al autenticar con Google');
      }
    } catch (error) {
      console.error('❌ Error procesando login:', error);
      onError('Error al procesar login con Google');
    }
  };

  const handleGoogleError = () => {
    console.error('❌ Error en Google Login');
    onError('Error al conectar con Google');
  };

  return (
    <GoogleLogin
      onSuccess={handleGoogleSuccess}
      onError={handleGoogleError}
      useOneTap={true} // Cambia a true si quieres One Tap automático
      theme="outline"
      size="large"
      text="continue_with"
      shape="rectangular"
      
      auto_select={true}
      logo_alignment='center'
      locale={lang === 'es' ? 'es' : 'en'}
      containerProps={{
        style:{
          width:"100% !important",
          fontFamily: 'Poppins, sans-serif !important'
        },
      }}

        
    />
  );
};